import CircleBadge from "../CircleBadge";
import {Button, TextInput} from "omoplay";
import {useEffect, useState} from "react";
import {getSpot, updateQRCode} from "../../../api/spot/spot.api";
import SuspensePopup from "../../SuspensePopup";
import QREditor from "../QREditor";

const EntryPointPreviewPopup = ({ show, spotId, onClose }) => {
    const [showPopup, setShowPopup] = useState(false)
    const [copy, setCopy] = useState(false)
    const [entryPoint, setEntryPoint] = useState({})
    const [showQrEdit, setShowQrEdit] = useState(false)
    const [qrShape, setQrShape] = useState({})
    const [reRender, setReRender] = useState(false)

    useEffect(() => {
        setShowPopup(show)
    }, [show]);

    useEffect(() => {
        if (spotId) {
            getSpot(spotId).then(({data}) => {
                setEntryPoint(data)
            })
        }
    }, [spotId, reRender]);

    const getFilenameFromResponse = (response, url) => {
        // 1. Content-Disposition 우선
        const disposition = response.headers.get('content-disposition')

        if (disposition) {
            const match = disposition.match(/filename="?([^"]+)"?/)

            if (match?.[1]) {
                return decodeURIComponent(match[1])
            }
        }

        // 2. URL 마지막 경로 사용
        const pathname = new URL(url).pathname
        const filename = pathname.split('/').pop()

        return filename || 'download'
    }

    const downloadImage = async (url) => {
        try {
            const response = await fetch(url)
            const blob = await response.blob()

            const filename = getFilenameFromResponse(response, url)

            const blobUrl = window.URL.createObjectURL(blob)

            const a = document.createElement('a')
            a.href = blobUrl
            a.download = filename

            document.body.appendChild(a)
            a.click()

            a.remove()
            window.URL.revokeObjectURL(blobUrl)
        } catch (e) {
            console.error(e)
        }
    }

  return (
      <>
          <SuspensePopup
              title={"고객 진입점 방식"}
              visible={showPopup}
              onClose={() => {
                  setShowPopup(false)
                  onClose()
              }}
          >
              <div className="flex-col gap-4 py-4">
                  <div>
                      <label className="flex-align-center gap-2">
                          <CircleBadge label={1} />
                          <div className="font-bold font-16px">
                              QR 이미지
                          </div>
                      </label>
                      <div className="text-grey-5">활용 예시 : 오프라인 홍보물, 오프라인 광고 디스플레이</div>
                  </div>
                  <div className="flex-col flex-center-all p-4 gap-4" style={{backgroundColor: "var(--color-shape-depth1, rgba(247, 247, 249, 1))"}}>
                      <img alt="" src={entryPoint.imageUrl} className="w-32 h-32"/>
                      <div className="flex-align-center gap-2">
                          <div><Button variants="primary" value="QR 수정" onClick={() => setShowQrEdit(true)} /></div>
                          <div><Button variants="secondary" value="이미지 다운" onClick={() => downloadImage(entryPoint.imageUrl)} /></div>
                      </div>
                  </div>
                  <div>
                      <label className="flex-align-center gap-2">
                          <CircleBadge label={2} />
                          <div className="font-bold font-16px">
                              URL 링크
                          </div>
                      </label>
                      <div className="text-grey-5">활용 예시 : 온라인 광고 링크</div>
                  </div>
                  <div className="flex-col gap-2">
                      <TextInput
                          disabled={true}
                          value={entryPoint.linkUrl}
                      />
                      <div className="flex gap-2">
                          <Button
                              variants="default"
                              onClick={() => window.open(entryPoint.linkUrl)}
                              value="URL 확인"
                          />
                          <Button
                              variants="secondary"
                              onClick={() => navigator.clipboard.writeText(entryPoint.linkUrl).then(() => {
                                  setCopy(true)
                              })}
                              value="URL 복사"
                          />
                          <div className={`flex-align-center ${!copy && 'none'}`} style={{bottom: "20px", right: "0", color: "red"}}>복사 되었습니다</div>
                      </div>
                  </div>
                  <div>
                      <label className="flex-align-center gap-2">
                          <CircleBadge label={3} />
                          <div className="font-bold font-16px">
                              진입점 비밀번호
                          </div>
                      </label>
                      <div className="text-grey-5">활용 예시 : 혜택 사용 시 사용한 지점 확인</div>
                  </div>
                  <div className="flex-col gap-2 w-[100px]">
                      <TextInput disabled={true} value={entryPoint.password} />
                  </div>
              </div>
          </SuspensePopup>
          <SuspensePopup
              title="QR 수정"
              visible={showQrEdit}
              onClose={() => setShowQrEdit(false)}
              confirmText="수정"
              onConfirm={() => {
                  updateQRCode(spotId, qrShape).then(() => {
                      setShowQrEdit(false)
                      setReRender(!reRender)
                  })
              }}
          >
              <QREditor onChangeType={(type) => setQrShape({...qrShape, type})}
                        onChangeLogo={(logo) => setQrShape({...qrShape, logo})}
                        onChangeUsedUid={(usedUid) => setQrShape({...qrShape, usedUid})}
              />
          </SuspensePopup>
      </>
  );
};
export default EntryPointPreviewPopup;
